const defaultTo = (defaultValue, value) => value ?? defaultValue;

export const InputBase = {
	inheritAttrs: false,
	props: {
		textarea: Boolean,
		label: String,
		defaultValue: String,
		customValidity: String,
	},
	watch: {
		customValidity: function(newValue) {
			this.$refs.input.setCustomValidity(defaultTo('', newValue));
		},
	},
	render(h) {
		let Tag = this.textarea ? 'textarea' : 'input';

		return (
			<div class="input-block">
				<Tag
					ref="input"
					class="input-block__input"
					domPropsValue={ this.defaultValue }
					attrs={ this.$attrs }
					onInput={(event) => this.$emit('input', event)}
				/>
				{ this.label ? (
					<label
						class="label input-block__label"
						for=""
					>
						{ this.label }
					</label>
				) : null }
				{ this.$slots.after }
			</div>
		);
	}
}
